export default __webpack_public_path__ + "static/char-s-06-kr-e92856cf98e093213e1a0a676a5c5b6f.png";